import React from 'react'
import { Table } from 'react-bootstrap'

import OcTabLayout from '../../layout/OcTabLayout'
import useOcOrderActions from '../../hooks/useOcOrderActions'

import { safeValue, safeMoney } from '../../helpers/tableUtils'

const OcErrorTab = ({
  purchaseOrder = {},
  downloads = {},
  lines = [],
  tabsOrders = {},
  onReprocessSuccess,
  summary = {},
  details = {}
}) => {
  const purchase_order_lines = Array.isArray(lines) ? lines : []

  const {
    downloadPurchaseOrder,
    reprocessPurchaseOrder,
    loadingDownload,
    loadingReprocess
  } = useOcOrderActions({
    purchaseOrderFileId: downloads.purchase_order_file_id,
    purchaseOrderFileName: downloads.file_name,
    orderId: tabsOrders?.order_id
  })

  const getLineStatus = (line) => {
    if (line.error_product_not_found) {
      return {
        label: line.error_product_not_found,
        className: 'oc-error-style'
      }
    }

    if (line.error_price_different_from_the_erp) {
      return {
        label: line.error_price_different_from_the_erp,
        className: 'oc-error-style'
      }
    }

    if (line.error_exceed_line_total) {
      return {
        label: line.error_exceed_line_total,
        className: 'oc-error-style'
      }
    }

    if (line.error_discontinued_products) {
      return {
        label: line.error_discontinued_products,
        className: 'oc-error-style'
      }
    }

    return {
      label: 'ERROR',
      className: 'oc-error-style'
    }
  }

  /*
   * REPROCESAR (PENDIENTE)
   * --------------------------------------------------
   * Esta acción se habilitará próximamente.
   * Aún se está definiendo:
   * - reglas de negocio
   * - validaciones necesarias
   * - comportamiento esperado en errores
   *
   * Se deja comentado intencionalmente.
   */
  // const handleReprocess = async () => {
  //   const res = await reprocessPurchaseOrder()
  //
  //   if (res?.success && res.new_order_id) {
  //     onReprocessSuccess(res.new_order_id)
  //   }
  // }

  return (
    <OcTabLayout
      isError={true}
      purchaseOrder={purchaseOrder}
      title={`Detalles de orden de compra`}
      errordetails={details}
      actions={[
        {
          label: 'DESCARGAR OC',
          icon: 'download_2',
          className: 'download-purchase-order',
          onClick: downloadPurchaseOrder,
          disabled: !downloads.purchase_order_file_id || loadingDownload
        }
        // {
        //   label: 'REPROCESAR',
        //   icon: 'refresh',
        //   className: 'reload-purchase-order',
        //   onClick: handleReprocess,
        //   disabled: loadingReprocess
        // }
      ]}
    >
      <b>Orden de compra:</b>
      <Table hover responsive className="mt-2 oc-fixed-table">
        <thead className="table-header-gray-poc">
          <tr>
            <th className="col-w-120">CÓDIGO BARRA</th>
            <th className="col-w-260">DESCRIPCIÓN</th>
            <th className="col-w-50">CANT.</th>
            <th className="col-w-50">EMPAQUE</th>
            <th className="col-w-50">PRECIO</th>
            <th className="col-w-50">TOTAL</th>
            <th className="col-w-70">ESTADO</th>
          </tr>
        </thead>

        <tbody>
          {purchase_order_lines.length === 0 ? (
            <tr>
              <td colSpan="7">No hay resultados</td>
            </tr>
          ) : (
            purchase_order_lines.map((line, index) => {
              const status = getLineStatus(line)

              return (
                <tr key={`${line.po_barcode}-${index}`}>
                  <td className="oc-td-text">
                    {safeValue(line.po_barcode)}
                  </td>
                  <td className="oc-td-text">
                    {safeValue(line.po_name)}
                  </td>
                  <td className="oc-td-text">
                    {safeValue(line.po_quantity)}
                  </td>
                  <td className="oc-td-text">
                    {safeValue(line.po_units_per_package)}
                  </td>
                  <td className="oc-td-money">
                    {safeMoney(line.po_price)}
                  </td>
                  <td className="oc-td-money">
                    {safeMoney(line.po_total_price)}
                  </td>
                  <td>
                    <span className={`oc-order-status-error ${status.className}`}>
                      {status.label}
                    </span>
                  </td>
                </tr>
              )
            })
          )}
        </tbody>
      </Table>
    </OcTabLayout>
  )
}

export default OcErrorTab
